import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/content";
import { Reveal } from "./Reveal";

export const Stories = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/stories`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <section id="stories" className="bg-paper text-pine py-24 md:py-32" data-testid="stories-section">
      <div className="max-w-6xl mx-auto px-6">
        <Reveal className="max-w-3xl mx-auto text-center">
          <p className="dp text-[120px] leading-none text-brass" aria-hidden="true">“</p>
          <h2 className="dp">Stories of restored marriages</h2>
          {items.length === 0 && (
            <p className="mt-6 text-moss" data-testid="stories-placeholder">Words from the couples we walk with will be shared here.</p>
          )}
        </Reveal>
        {items.length > 0 && (
          <div className={`mt-14 grid gap-6 ${items.length > 1 ? "md:grid-cols-2" : "max-w-2xl mx-auto"}`} data-testid="stories-list">
            {items.map((s, i) => (
              <Reveal as="figure" key={s.id} delay={(i % 2) * 120} className={`bg-sage rounded-2xl p-8 md:p-10 ${i % 2 ? "md:mt-12" : ""}`} data-testid={`story-${s.id}`}>
                <blockquote className="dp text-2xl leading-snug whitespace-pre-line">“{s.story}”</blockquote>
                <figcaption className="mt-6 lb text-brass-ink">{s.couple}</figcaption>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
